import createFromRecipientWell from './createFromRecipientWell';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export default function createFromViewState(isFromShown, fromAddress) {
    return {
        from: createFromRecipientWell(fromAddress),
        isFromShown: isFromShown,
        isFromContextMenuShown: false,
        sendAsEmailAddresses: [],
        loadAliasActionStatus: isConsumer()
            ? 0 /* NotStarted */
            : 2 /* Finished */,
    };
}
//# sourceMappingURL=createFromViewState.js.map